import { type Asset } from '@/services/db/asset/entity';

export function isPdf(asset: Asset): boolean {
  return asset.name.toLowerCase().endsWith('.pdf');
}
